/**
 * `/v1/search` in local mode (plan §6.6 search contract).
 *
 * Thin by design. The matching AND ordering rules live in the shared
 * `core` selector so both adapters run the same code — that is what makes the
 * "ticker-prefix first, then name-substring, ticker ascending within each
 * group" contract provable rather than merely fixture-tested.
 */
import type { SearchQuery, Security } from '@meridian/contracts';

import { searchSecurities } from '../../selectors/search-securities';
import { toWireSecurity, type DerivedSecurity } from '../../universe/derive-security';

export function runSearch(
  rows: readonly DerivedSecurity[],
  query: SearchQuery,
): readonly Security[] {
  return searchSecurities(rows, query.q, query.limit).map(toWireSecurity);
}
